export const GetEventInputValue = (event, trimInput)=>{
    return (event.target.type === 'checkbox')? event.target.checked: (
        trimInput? event.target.value && event.target.value.trim(): event.target.value
    );
};

export function isValidEmail(email) {
  const EMAIL_REGEX =
    /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/;

  const INVALID_SUFFIXES = [
    ".con",
    ".cm",
    ".comau",
    ".con.au",
    "comn",
    "com4",
    "comp",
    ".a",
    ".u",
    ".ay",
    ".vom",
    ".aui",
    ".cim",
    ".gmail",
  ];

  const normalized = (email ?? "")?.trim()?.toLowerCase();

  if (normalized.length === 0) return false;

  if (!EMAIL_REGEX.test(normalized)) return false;

  for (const bad of INVALID_SUFFIXES) {
    if (normalized.endsWith(bad)) {
      return false;
    }
  }

  return true;
}


const ValidateForRequiredInput = ({isRequiredMessage, label, value})=>{
    
    if(!value || value.length === 0)
        return isRequiredMessage || `${label} can't be empty, please provide a valid ${label}`;
    return null; 
};


export const ValidateFormView = ({fields, model})=>{
    const errors = {};
    fields.forEach(field=>{
        let err = null;
        const value = model[field.name];
        if(field.required)
        {
            err = ValidateForRequiredInput({
                isRequiredMessage: field.isRequiredMessage,
                label: field.label || field.name,
                value
            });
    
            if(err)
                errors[field.name] = err;
        }
        
        if(!err && field.type === 'email')
        {
            if(value && !isValidEmail(value))
                errors[field.name] = "Please provide a valid email address.";   
        }

        if(!err && field.validate && typeof field.validate === 'function')
        {
            err = field.validate(value, model);
            if(err)
                errors[field.name] = err;
        }
    });

    return errors;
};